var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMhoRightArrowWhiteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 9,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.32959 15.6652C-0.105225 15.2235-0.109741 14.5102 0.316101 14.0629L0.32959 14.049 6.28406 7.99994 0.32959 1.95093C-0.105225 1.50922-0.109741 0.795868 0.316101 0.348572L0.32959 0.334686C0.764404-0.107025 1.46655-0.111603 1.90686 0.321014L1.92053 0.334686 8.67053 7.1918C9.10535 7.63351 9.10986 8.34686 8.68402 8.79416L8.67053 8.80807 1.92053 15.6652C1.4812 16.1115 0.768921 16.1115 0.32959 15.6652Z",
    fill: "#FFFFFF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMhoRightArrowWhiteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mho-right-arrow-white-icon.6640dd6fbf3ef6c2420f6c2edfe3ed56.svg";